// extracted by mini-css-extract-plugin
export var headerWord = "HeadingThird-module--headerWord--1PpIQ";
export var headerWordAnimation = "HeadingThird-module--headerWordAnimation--FMmfJ";
export var light = "HeadingThird-module--light--SGj_h";
export var dark = "HeadingThird-module--dark--1YxUr";